import React, { useEffect, useState } from "react";
import styled from "styled-components";

import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import EventBtn from "./../../../component/atoms/button/eventBtn";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import PretendardText from "../../../component/atoms/text/pretendardText";
import ImgInputLarge from "../../../component/atoms/input/imgInputLarge";
import MainInput from "./../../../component/atoms/input/mainInput";
import Checkbox from "./../../../component/atoms/input/checkbox";
import BasicBtn from "./../../../component/atoms/button/basicBtn";

import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";

import TableCount from "./../../../component/molecules/tableCount";
import scrollToTop from "../../../util/scrollToTop";

import ImgPreviewLarge from "../../../component/molecules/imgPreviewLarge";
import Empty from "../../../component/molecules/empty";
import { errorHandler } from "../../../util/errorHandler";
import FirstVisitApi from "../../../api/firstVisit.api";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import Modal from "../../../component/templates/Modal";
import FileApi from "../../../api/file.api";
import { fileUrl } from "../../../api/api";
import { route } from "../../../router/route";

const KnowledgeFirstVisit = () => {
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.knowledge_first_visit)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 썸네일 및 배너 설정 ---------- //
  const [firstVisitList, setFirstVisitList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [delId, setDelId] = useState(0);

  useEffect(() => {
    getFirstVisitListFunc();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getFirstVisitListFunc = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
      };

      const response = (await FirstVisitApi.getList(data)).data.data;

      setTotalCount(response.totalCount);
      setFirstVisitList(response.content);
    } catch (error) {
      errorHandler(error);
    }
  };

  const createFirstVisitFunc = async () => {
    try {
      await FirstVisitApi.create();

      toast(toastMsg.create);
      await getFirstVisitListFunc();
    } catch (error) {
      errorHandler(error);
    }
  };

  const delFirstVisitFunc = async () => {
    try {
      const data = {
        ids: [delId],
        allFlag: false,
      };
      await FirstVisitApi.delete(data);

      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      await getFirstVisitListFunc();
    } catch (error) {
      errorHandler(error);
    }
  };

  const editFirstVisitFunc = async (firstVisitInfo) => {
    try {
      const data = {
        id: firstVisitInfo.id,
        link: firstVisitInfo.link,
        newOpen: firstVisitInfo.newOpen,
      };

      if (firstVisitInfo.pcFileUrl) {
        const pcImageResponse = await FileApi.fileUpload(
          firstVisitInfo.pcFile,
          "admin/first-visit"
        );

        data.imageOriginFileNamePc = pcImageResponse.data.data.originalFileName;
        data.imageServerFileNamePc = pcImageResponse.data.data.serverFileName;
      } else {
        data.imageOriginFileNamePc = firstVisitInfo.imageOriginFileNamePc;
        data.imageServerFileNamePc = firstVisitInfo.imageServerFileNamePc;
      }

      if (firstVisitInfo.moFileUrl) {
        const moImageResponse = await FileApi.fileUpload(
          firstVisitInfo.moFile,
          "admin/first-visit"
        );
        data.imageOriginFileNameMo = moImageResponse.data.data.originalFileName;
        data.imageServerFileNameMo = moImageResponse.data.data.serverFileName;
      } else {
        data.imageOriginFileNameMo = firstVisitInfo.imageOriginFileNameMo;
        data.imageServerFileNameMo = firstVisitInfo.imageServerFileNameMo;
      }

      await FirstVisitApi.update(data.id, data);
      toast(toastMsg.create);
      await getFirstVisitListFunc();
    } catch (error) {
      errorHandler(error);
    }
  };

  const inputFile = (e, type, index) => {
    const file = e.target.files[0];

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    let firstVisitTemp = [...firstVisitList];

    if (type === "pc") {
      fileReader.onload = (value) => {
        firstVisitTemp[index].pcFile = file;
        firstVisitTemp[index].pcFileUrl = value.target.result;
        firstVisitTemp[index].pcFileName = file.name;
        setFirstVisitList(firstVisitTemp);
      };
    } else if (type === "mobile") {
      fileReader.onload = (value) => {
        firstVisitTemp[index].moFile = file;
        firstVisitTemp[index].moFileUrl = value.target.result;
        firstVisitTemp[index].moFileName = file.name;
        setFirstVisitList(firstVisitTemp);
      };
    }
    e.target.value = "";
  };

  const deleteFile = (type, index) => {
    let firstVisitTemp = [...firstVisitList];

    if (type === "pc") {
      firstVisitTemp[index].pcFile = null;
      firstVisitTemp[index].pcFileUrl = null;
      firstVisitTemp[index].pcFileName = null;
      firstVisitTemp[index].imageOriginFileNamePc = null;
      firstVisitTemp[index].imageServerFileNamePc = null;
    } else if (type === "mobile") {
      firstVisitTemp[index].moFile = null;
      firstVisitTemp[index].moFileUrl = null;
      firstVisitTemp[index].moFileName = null;
      firstVisitTemp[index].imageOriginFileNameMo = null;
      firstVisitTemp[index].imageServerFileNameMo = null;
    }

    setFirstVisitList(firstVisitTemp);
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>첫 방문이라면? 관리</TableTitle>
          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount text={"배너"} count={totalCount} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              {isWriteAuthority && (
                <EventBtn
                  text={"배너 추가하기"}
                  onClick={() => {
                    createFirstVisitFunc();
                    scrollToTop();
                  }}
                />
              )}
            </div>
          </TableTop>

          {firstVisitList.length > 0 ? (
            firstVisitList.map((item, index) => {
              return (
                <DetailPage key={index}>
                  <FirstVisitTitleWrapper>
                    <FirstVisitTitleText>배너{index + 1}</FirstVisitTitleText>
                    {isWriteAuthority && (
                      <FirstVisitDelete
                        onClick={() => {
                          setDelId(item.id);
                          setDeleteModalOpen(true);
                        }}
                      >
                        삭제하기
                      </FirstVisitDelete>
                    )}
                  </FirstVisitTitleWrapper>
                  <FirstVisitImgContainer>
                    <FirstVisitImgWrapper>
                      <PretendardText
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          lineHeight: "22.75px",
                          color: "#aaa",
                          marginBottom: "12px",
                        }}
                      >
                        PC 배너 등록
                      </PretendardText>
                      {item.imageServerFileNamePc || item.pcFileUrl ? (
                        <ImgPreviewLarge
                          fileUrl={
                            item.pcFileUrl
                              ? item.pcFileUrl
                              : `${fileUrl}/${item.imageServerFileNamePc}`
                          }
                          onClick={() => {
                            deleteFile("pc", index);
                          }}
                        />
                      ) : (
                        <ImgInputLarge
                          id={"pc"}
                          accept={"image/*"}
                          onChange={(e) => {
                            inputFile(e, "pc", index);
                          }}
                        />
                      )}
                      <div
                        style={{
                          width: "100%",
                          marginTop: 12,
                        }}
                      >
                        <PretendardText
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            lineHeight: "22.75px",
                            color: "rgba(181, 181, 181, 0.5)",
                          }}
                        >
                          최적 size
                        </PretendardText>
                        <ul
                          style={{
                            listStyle: "disc",
                            listStylePosition: "inside",
                            listColor: "rgba(181, 181, 181, 0.5)",
                          }}
                        >
                          <li
                            style={{
                              fontFamily: "Pretendard",
                              fontSize: "14px",
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              color: "rgba(181, 181, 181, 0.5)",
                            }}
                          >
                            752*300
                          </li>
                        </ul>
                      </div>
                    </FirstVisitImgWrapper>
                    <FirstVisitImgWrapper>
                      <PretendardText
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          lineHeight: "22.75px",
                          color: "#aaa",
                          marginBottom: "12px",
                        }}
                      >
                        Mobile 배너 등록
                      </PretendardText>
                      {item.imageServerFileNameMo || item.moFileUrl ? (
                        <ImgPreviewLarge
                          fileUrl={
                            item.moFileUrl
                              ? item.moFileUrl
                              : `${fileUrl}/${item.imageServerFileNameMo}`
                          }
                          onClick={() => {
                            deleteFile("mobile", index);
                          }}
                        />
                      ) : (
                        <ImgInputLarge
                          id={"mobile"}
                          accept={"image/*"}
                          onChange={(e) => {
                            inputFile(e, "mobile", index);
                          }}
                        />
                      )}
                      <div
                        style={{
                          width: "100%",
                          marginTop: 12,
                        }}
                      >
                        <PretendardText
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            lineHeight: "22.75px",
                            color: "rgba(181, 181, 181, 0.5)",
                          }}
                        >
                          최적 size
                        </PretendardText>
                        <ul
                          style={{
                            listStyle: "disc",
                            listStylePosition: "inside",
                            listColor: "rgba(181, 181, 181, 0.5)",
                          }}
                        >
                          <li
                            style={{
                              fontFamily: "Pretendard",
                              fontSize: "14px",
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              color: "rgba(181, 181, 181, 0.5)",
                            }}
                          >
                            343*380
                          </li>
                        </ul>
                      </div>
                    </FirstVisitImgWrapper>
                  </FirstVisitImgContainer>
                  <ImgLinkContainer>
                    <ImgLinkWrapper>
                      <ImgLinkTitle>이미지 연결링크</ImgLinkTitle>
                      <MainInput
                        type={"text"}
                        placeholder={"https://www.example.com"}
                        style={{ width: "338px" }}
                        value={item.link}
                        onChange={(e) => {
                          let firstVisitTemp = [...firstVisitList];
                          firstVisitTemp[index].link = e.target.value;

                          setFirstVisitList(firstVisitTemp);
                        }}
                      />
                    </ImgLinkWrapper>
                    <div
                      style={{
                        width: "100%",
                        paddingLeft: 122,
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        marginTop: "10px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        let firstVisitTemp = [...firstVisitList];
                        firstVisitTemp[index].newOpen = !item.newOpen;

                        setFirstVisitList(firstVisitTemp);
                      }}
                    >
                      <Checkbox
                        style={{
                          backgroundColor: "transparent",
                        }}
                        checked={item.newOpen}
                        onChange={() => {}}
                      />
                      <PretendardText
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                          lineHeight: "21.5px",
                          color: "#aaa",
                        }}
                      >
                        새 창에서 열기
                      </PretendardText>
                    </div>
                  </ImgLinkContainer>

                  <div
                    style={{
                      width: "100%",
                      height: 79,
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                      gap: 12,
                    }}
                  >
                    {isWriteAuthority && (
                      <BasicBtn
                        onClick={() => {
                          editFirstVisitFunc(item);
                        }}
                      >
                        저장하기
                      </BasicBtn>
                    )}
                  </div>
                </DetailPage>
              );
            })
          ) : (
            <Empty />
          )}
        </DetailPageLayout>
      </MainLayout>

      {/* 삭제 모달 */}
      {deleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteModalOpen}
          onClick={delFirstVisitFunc}
        />
      )}
    </>
  );
};

export default KnowledgeFirstVisit;

const FirstVisitTitleWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0px 20px 0px;
`;

const FirstVisitTitleText = styled(PretendardText).attrs((props) => {})`
  font-weight: 600;
  font-size: 18px;
  line-height: 32.5px;
  color: #f3f3f3;
`;

const FirstVisitDelete = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 15px;
  line-height: 21.5px;
  color: rgba(181, 181, 181, 0.5);
  text-decoration: underline;

  cursor: pointer;
`;

const FirstVisitImgContainer = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  gap: 20px;
`;

const FirstVisitImgWrapper = styled.div.attrs((props) => {})`
  width: 254px;
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ImgLinkContainer = styled.div.attrs((props) => {})`
  width: 100%;
  height: 122px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  padding: 21px 0px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  margin-top: 24px;
`;

const ImgLinkWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  gap: 33px;
`;

const ImgLinkTitle = styled(PretendardText).attrs((props) => {})`
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
`;
